function t(t){return"string"==typeof t}export{t as i};
